import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import WorkExamplesPage from './pages/WorkExamplesPage.jsx';
import Navigation from './components/Navigation';
import { FaLinkedin, FaEnvelope, FaGithub } from 'react-icons/fa';

function App() {

  return (
    
    <>
    <div className="app">
     <img src= "trish.jpg" alt="photo of Trish, this website's owner"class = "responsive-image"></img><header><h1>Trish Stackpole</h1>
        
      </header>
      </div>
      
               
        <Router>
          <Navigation/>
          <Routes>
            <Route path="/" element={<HomePage />}></Route>
            <Route path="/contact-page" element={ <ContactPage  />}></Route>
            <Route path="/work-examples-page" element={ <WorkExamplesPage   />}></Route>
          </Routes>
        </Router>

    
        
        <footer><p>© 2025 Trish Stackpole</p>
        <p><a href ="https://www.linkedin.com/in/trish-stackpole/"  target="_blank" rel="noopener noreferrer">
        <FaLinkedin size={32} color="#0A66C2" /></a>
          <a href="mailto:trish@stackpop.dev" target="_blank" rel="noopener noreferrer">
        <FaEnvelope size={32} color="#0A66C2" />
      </a><a href="https://github.com/stackpop2010/" target="_blank" rel="noopener noreferrer">
        <FaGithub size={32} color="#0A66C2" />
      </a>
      </p> </footer>
        
       
    
    </>
  );
}

export default App;